import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from './components/pages/login/login.component';
import {AuthGuard} from './providers/guards/auth.guard';
import {CONSTANTS} from './constants';
import {AlertsViewComponent} from './components/pages/alerts-view/alerts-view.component';
import {MissionConfigComponent} from './components/pages/mission-config/mission-config.component';
import {MaterialConfigComponent} from './components/pages/material-config/material-config.component';
import {ProductConfigComponent} from './components/pages/product-config/product-config.component';
import {MissionSelectionComponent} from './components/pages/mission-selection/mission-selection.component';
import {HomeComponent} from './components/pages/home/home.component';
import {MissionConfigMenuComponent} from './components/pages/mission-config-menu/mission-config-menu.component';
import {TeamConfigComponent} from './components/pages/team-config/team-config.component';
import {SupportConfigComponent} from './components/pages/support-config/support-config.component';
import {ContainersComponent} from './components/pages/containers/containers.component';
import {TeamsComponent} from './components/pages/teams/teams.component';
import {MissionInfoComponent} from './components/pages/mission-info/mission-info.component';
import {MissionCreateComponent} from "./components/pages/mission-create/mission-create.component";
import {MissionResolver} from "./providers/resolvers/mission.resolver";
import {MissionComponent} from "./components/pages/mission/mission.component";
import { ParticipantsConfigComponent } from './components/pages/participants-config/participants-config.component';

const routes: Routes = [
  {path: '', redirectTo: CONSTANTS.ROUTES.LOGIN, pathMatch: 'full'},
  {path: CONSTANTS.ROUTES.LOGIN, component: LoginComponent},
  {
    path: CONSTANTS.ROUTES.HOME, component: HomeComponent, canActivate: [AuthGuard],
    children: [
      {path: '', redirectTo: CONSTANTS.ROUTES.MISSION_SELECTION, pathMatch: 'full'},
      {path: CONSTANTS.ROUTES.MISSION_SELECTION, component: MissionSelectionComponent},
      {
        path: CONSTANTS.ROUTES.MISSION_CONFIG, component: MissionConfigComponent,
        children: [
          {path: '', redirectTo: CONSTANTS.ROUTES.MISSION_CONFIG_MENU, pathMatch: 'full'},
          {path: CONSTANTS.ROUTES.MISSION_CONFIG_MENU, component: MissionConfigMenuComponent},
          {path: CONSTANTS.ROUTES.MISSION_INFO, component: MissionInfoComponent},
          {path: `${CONSTANTS.ROUTES.MATERIAL_CONFIG}/:missionId`, component: MaterialConfigComponent},
          {path: CONSTANTS.ROUTES.MATERIAL_CONFIG, component: MaterialConfigComponent},
          {path: CONSTANTS.ROUTES.PRODUCT_CONFIG, component: ProductConfigComponent},
          {path: CONSTANTS.ROUTES.TEAM_CONFIG, component: TeamConfigComponent},
          {path: CONSTANTS.ROUTES.SUPPORT_CONFIG, component: SupportConfigComponent},
          {path: CONSTANTS.ROUTES.PARTICIPANTS_CONFIG, component: ParticipantsConfigComponent},
          {
            path: ':missionId',
            children: [
              {path: '', redirectTo: CONSTANTS.ROUTES.MISSION_CONFIG_MENU, pathMatch: 'full'},
              {path: CONSTANTS.ROUTES.MISSION_CONFIG_MENU, component: MissionConfigMenuComponent},
              {path: CONSTANTS.ROUTES.MISSION_INFO, component: MissionInfoComponent},
              {path: CONSTANTS.ROUTES.MATERIAL_CONFIG, component: MaterialConfigComponent},
              {path: CONSTANTS.ROUTES.PRODUCT_CONFIG, component: ProductConfigComponent},
              {path: CONSTANTS.ROUTES.TEAM_CONFIG, component: TeamConfigComponent},
              {path: CONSTANTS.ROUTES.SUPPORT_CONFIG, component: SupportConfigComponent},
              {path: CONSTANTS.ROUTES.PARTICIPANTS_CONFIG, component: ParticipantsConfigComponent}
            ]
          }
        ]
      },
      {
        path: CONSTANTS.ROUTES.MISSION, canActivate: [AuthGuard],
        children: [
          {path: '', redirectTo: CONSTANTS.ROUTES.MISSION_SELECTION, pathMatch: 'full'},
          {path: ':missionId', component: MissionComponent, resolve: {mission: MissionResolver},
          }
        ]
      },
      {path: CONSTANTS.ROUTES.CONTAINERS, component: ContainersComponent},
      {path: CONSTANTS.ROUTES.TEAMS, component: TeamsComponent},
      {path: CONSTANTS.ROUTES.ALERTS_VIEW, component: AlertsViewComponent},
      {path: CONSTANTS.ROUTES.NEW_MISSION, component: MissionCreateComponent},
    ]
  },

  // otherwise redirect to home
  {path: '**', redirectTo: CONSTANTS.ROUTES.HOME}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
